import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { formatSalary } from "../../../helpers/format";
import LocaleLink from '../../Routes/LocaleLink'
import {faArrowRight} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class JobCard extends Component
{
    handleTextLength(text) {
        if(text){
            return text.length > 75 ? text.substring(0, 74) + '...' : text
        }
    }

    render() {
        const {offer} = this.props;
        if (!offer) return null;

        return(
            <>
                <LocaleLink to={"/jobs/" + offer.business_unit + '/' + offer.slug} className={"job-info-block " + this.props.className}>
                    <div className="job-title" ref={(title_element) => { this.title_element = title_element }}>
                        <h3>{offer.title}</h3>
                        { offer.address ?
                            <span>{offer.address.city}, {offer.address.country.name}</span>
                            : null
                        }
                        <div className="tiny-img">
                            <img src={offer.owner.attachment ? offer.owner.attachment.url : 'https://via.placeholder.com/150'} alt="img"/>
                        </div>
                    </div>
                    <div className="job-desc-text">
                        <p>
                            {this.handleTextLength(offer.hat)}
                        </p>
                        {this.renderKeywords(offer.keywords)}
                    </div>
                    <ul className="tech-list d-flex align-items-center">
                        <li>{offer.business_unit}</li>
                        <li>{offer.type}</li>
                        { offer.salary_low != 0 && offer.salary != 0 ?
                            <li>
                                {formatSalary(offer.salary_low)}
                                {' '}
                                <FormattedMessage id={"wording.to"} defaultMessage={"à"}/>
                                {' '}
                                {formatSalary(offer.salary)}
                            </li>
                            : null
                        }
                        <li className="arrow-link"><FontAwesomeIcon icon={faArrowRight} /></li>
                    </ul>
                </LocaleLink>
            </>
        )
    }

    renderKeywords(keywords) {

        if (!keywords) return null;

        return (
            <ul className="lang-list d-flex">
                {keywords.split(' ').map((keyword, key) => {
                    return (
                        <li key={key}>{keyword}</li>
                    )
                })}
            </ul>
        )
    }
}

export default JobCard;
